module.exports = __webpack_public_path__ + "img/P3.48e348b.svg";